export default "__VITE_ASSET__5uoMvIJj__"